/* HC okt 2026: productkaarten met fotoslider (zelfde gedrag als FinalPutt).
   - Elke kaart krijgt een slider met alle foto's: swipen op mobiel, pijltjes + streepjes op desktop (zichtbaar bij hover).
   - Kaarten met kleurbolletjes tonen de fotoreeks van de actieve kleur (data-series uit snippets/product-card-swatch.liquid).
     Hover (desktop) of klik/tik op een bolletje wisselt de reeks; klikken op een bolletje opent nooit de productpagina.
   - Bron van alle foto's: data-hc-images op de figure (snippets/product-card.liquid).
   - In carrousels (homepage) vangt de fotoslider zelf de swipe op; knoppen staan onderaan uitgelijnd.
   Geladen via snippets/hc-copy-fixes.liquid op pagina's met productkaarten. */
(function () {
  var touch = window.matchMedia('(hover: none) and (pointer: coarse)').matches || !!window.hcSwipeForce;

  var css = [
    '.hc-cs{position:absolute;inset:0;z-index:11;overflow:hidden;background:var(--bg-body,#f9f9f9)}',
    '.hc-cs-track{position:absolute;inset:0;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;overscroll-behavior-x:contain}',
    '.hc-cs-track::-webkit-scrollbar{display:none}',
    '.hc-cs-slide{position:relative;flex:0 0 100%;width:100%;height:100%;scroll-snap-align:start;scroll-snap-stop:always;background:var(--bg-body,#f9f9f9);isolation:isolate}',
    '.hc-cs-slide a{display:block;width:100%;height:100%}',
    '.hc-cs-slide img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:1!important;opacity:1!important;max-width:none!important;mix-blend-mode:multiply!important}',
    '.hc-cs-dots{position:absolute;left:0;right:0;bottom:4px;z-index:15;display:flex;gap:4px;padding:0 4px}',
    '.hc-cs-dots span{flex:1 1 0;height:2px;border-radius:30px;background:rgba(255,255,255,.64);box-shadow:0 0 1px rgba(0,0,0,.45);cursor:pointer}',
    '.hc-cs-dots span.on{background:#fff}',
    '.hc-cs-prev,.hc-cs-next{position:absolute;top:50%;transform:translateY(-50%);z-index:20;display:none;align-items:center;justify-content:center;width:32px;height:32px;padding:0;border:0;border-radius:2px;background:rgba(249,249,249,.8);box-shadow:0 0 12px rgba(0,0,0,.32);color:#151515;cursor:pointer}',
    '.hc-cs-prev svg,.hc-cs-next svg{display:block;width:16px;height:16px}',
    '.hc-cs-prev{left:10px}.hc-cs-next{right:10px}',
    '@media only screen and (min-width:768px){.hc-cs-prev,.hc-cs-next{width:40px;height:40px;display:flex}.hc-cs-prev svg,.hc-cs-next svg{width:20px;height:20px}.hc-cs-prev{left:18px}.hc-cs-next{right:18px}}',
    '@media (hover:hover) and (pointer:fine){.hc-cs-prev,.hc-cs-next,.hc-cs-dots{opacity:0;visibility:hidden;transition:opacity .25s ease,visibility .25s ease}product-card:hover .hc-cs-prev,product-card:hover .hc-cs-next,product-card:hover .hc-cs-dots,.hc-cs-prev:focus-visible,.hc-cs-next:focus-visible{opacity:1;visibility:visible}}',
    '.hc-cs-single .hc-cs-prev,.hc-cs-single .hc-cs-next,.hc-cs-single .hc-cs-dots{display:none!important}',
    '.hc-cs-on .product-card--featured-image-link>img,.hc-cs-on .product-card--featured-image-link>.product-primary-image,.hc-cs-on .product-card--featured-image-link>.product-secondary-image{visibility:hidden!important}',
    '.hc-cs-on .product-secondary-images-nav{display:none!important}',
    '.hc-cs-on .product-card--badges{z-index:13}',
    '.hc-cs-on .product-card-quickview,.hc-cs-on .product-card-size-options{z-index:13}',
    /* knoppen op één lijn, ook als een kaart kleurbolletjes of een langere titel heeft (carrousels en grids) */
    '.products.carousel .carousel__slide>product-card.product-card{flex:1 1 auto;align-self:stretch;height:auto!important;min-height:0}',
    'product-card.product-card .product-card-info{flex:1 1 auto}',
    'product-card.product-card .product-card--add-to-cart-button-container{margin-top:auto}'
  ].join('\n');
  var st = document.createElement('style');
  st.id = 'hc-swipe-css';
  st.textContent = css;
  document.head.appendChild(st);

  var ARROW_L = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M12.5 4.375 6.875 10l5.625 5.625" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  var ARROW_R = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="m7.5 4.375 5.625 5.625L7.5 15.625" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  function srcOf(img) {
    return img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
  }
  function sized(u, w) {
    if (!u) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$1' + w);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function list(attr) {
    return (attr || '').split('|').filter(Boolean);
  }

  /* (her)vul de slider van een kaart */
  function fill(cs, urls, alt) {
    var href = cs.hcLink.getAttribute('href');
    var track = cs.hcTrack, dots = cs.hcDots;
    track.innerHTML = '';
    dots.innerHTML = '';
    cs.classList.toggle('hc-cs-single', urls.length < 2);
    urls.forEach(function (u, i) {
      var s = document.createElement('div');
      s.className = 'hc-cs-slide';
      var img = document.createElement('img');
      img.alt = alt || '';
      img.decoding = 'async';
      img.draggable = false;
      if (i) img.loading = 'lazy';
      img.src = sized(u, 375);
      img.srcset = sized(u, 375) + ' 375w, ' + sized(u, 770) + ' 770w';
      img.sizes = '(min-width: 768px) 25vw, 50vw';
      var a = document.createElement('a');
      a.href = href;
      a.tabIndex = i ? -1 : 0;
      a.setAttribute('aria-label', alt || '');
      a.draggable = false;
      a.appendChild(img);
      s.appendChild(a);
      track.appendChild(s);
      var d = document.createElement('span');
      if (!i) d.className = 'on';
      d.addEventListener('click', function (e) { e.preventDefault(); go(cs, i); });
      dots.appendChild(d);
    });
    track.scrollLeft = 0;
    cs.hcIndex = 0;
  }

  function count(cs) { return cs.hcTrack.children.length; }
  function go(cs, i) {
    var n = count(cs);
    if (!n) return;
    i = ((i % n) + n) % n; /* rewind zoals FinalPutt */
    cs.hcTrack.scrollTo({ left: i * cs.hcTrack.clientWidth, behavior: 'smooth' });
  }
  function current(cs) {
    return Math.round(cs.hcTrack.scrollLeft / Math.max(cs.hcTrack.clientWidth, 1));
  }

  function activeSwatch(card) {
    return card.querySelector('.product-card-swatch.active') || card.querySelector('.product-card-swatch');
  }

  function init(fig) {
    if (fig.dataset.hcCs) return;
    var card = fig.closest('product-card');
    var link = fig.querySelector('.product-card--featured-image-link');
    if (!card || !link) return;
    var prim = link.querySelector('.product-primary-image');
    var urls = list(fig.getAttribute('data-hc-images'));
    if (!urls.length) {
      var imgs = [].slice.call(link.querySelectorAll('.product-primary-image, .product-secondary-image'));
      urls = imgs.map(srcOf).filter(Boolean);
    }
    var sw = activeSwatch(card);
    var series = sw ? list(sw.getAttribute('data-series')) : [];
    if (series.length) urls = series;
    if (!urls.length) return;
    fig.dataset.hcCs = '1';

    var cs = document.createElement('div');
    cs.className = 'hc-cs';
    cs.innerHTML = '<div class="hc-cs-track"></div><div class="hc-cs-dots"></div>' +
      '<button type="button" class="hc-cs-prev" aria-label="Previous slide">' + ARROW_L + '</button>' +
      '<button type="button" class="hc-cs-next" aria-label="Next slide">' + ARROW_R + '</button>';
    cs.hcTrack = cs.querySelector('.hc-cs-track');
    cs.hcDots = cs.querySelector('.hc-cs-dots');
    cs.hcLink = link;
    link.insertAdjacentElement('afterend', cs);
    fig.classList.add('hc-cs-on');
    card.hcCs = cs;

    if (sw && series.length && sw.getAttribute('data-href')) {
      [].forEach.call(card.querySelectorAll('a.product-card--featured-image-link, a.product-card-title'), function (a) { a.setAttribute('href', sw.getAttribute('data-href')); });
    }
    fill(cs, urls, (prim && prim.alt) || link.getAttribute('title') || '');

    /* slider staat naast de kaartlink; elke slide heeft een eigen link */
    cs.querySelector('.hc-cs-prev').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(cs, current(cs) - 1); });
    cs.querySelector('.hc-cs-next').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(cs, current(cs) + 1); });
    cs.hcDots.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });


    var t;
    cs.hcTrack.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = current(cs);
        [].forEach.call(cs.hcDots.children, function (d, k) { d.className = k === i ? 'on' : ''; });
      }, 60);
    }, { passive: true });
  }

  /* Kleurbolletje: reeks van die kleur tonen + links naar de driver-variant van die kleur */
  function applySeries(sw) {
    var card = sw.closest('product-card');
    if (!card) return;
    var urls = list(sw.getAttribute('data-series'));
    var href = sw.getAttribute('data-href');
    if (href) {
      [].forEach.call(card.querySelectorAll('a.product-card--featured-image-link, a.product-card-title'), function (a) { a.setAttribute('href', href); });
    }
    var cs = card.hcCs;
    if (cs && urls.length) {
      var prim = card.querySelector('.product-primary-image');
      fill(cs, urls, prim ? prim.alt : '');
    }
  }

  function setActive(sw) {
    var all = sw.parentNode ? sw.parentNode.querySelectorAll('.product-card-swatch') : [];
    [].forEach.call(all, function (el) { el.classList.remove('active', 'hc-cur'); });
    sw.classList.add('active', 'hc-cur');
  }
  if (!touch) {
    /* desktop: hover op een bolletje wisselt de reeks */
    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest && e.target.closest('product-card .product-card-swatch');
      if (sw && !sw.classList.contains('hc-cur')) {
        setActive(sw);
        applySeries(sw);
      }
    }, true);
  }
  /* klik/tik op een bolletje: alleen de reeks wisselen, nooit naar de productpagina */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('product-card .product-card-swatch');
    if (!sw) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    setActive(sw);
    applySeries(sw);
  }, true);

  /* In een carrousel (Flickity): swipen over de foto's bladert door de foto's, niet door de carrousel.
     iOS laat het native horizontaal scrollen binnen de carrousel niet toe (touch-action van Flickity), daarom
     doen we het swipen hier zelf: op window in de capture-fase (altijd vóór Flickity), Flickity-slepen staat uit
     zolang de vinger op de foto staat. Verticaal vegen blijft gewoon de pagina scrollen. */
  var hcT = null;
  function hcSlider(tr) {
    var slider = tr.closest('.flickity-enabled');
    return slider && window.Flickity ? window.Flickity.data(slider) : null;
  }
  function hcTouchStart(e) {
    var tr = e.target && e.target.closest && e.target.closest('.hc-cs-track');
    if (!tr) return;
    var fl = hcSlider(tr);
    if (!fl) return;
    if (fl.isDraggable) fl.isDraggable = false; else fl = null;
    var p = e.touches ? e.touches[0] : e;
    hcT = { tr: tr, fl: fl, x: p.clientX, y: p.clientY, sl: tr.scrollLeft, dir: null, dx: 0 };
    e.stopPropagation();
  }
  function hcTouchMove(e) {
    if (!hcT || !e.touches) return;
    var p = e.touches[0];
    var dx = p.clientX - hcT.x, dy = p.clientY - hcT.y;
    if (!hcT.dir && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
      hcT.dir = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (hcT.dir === 'x') hcT.tr.style.scrollSnapType = 'none';
    }
    if (hcT.dir === 'x') {
      e.preventDefault();
      hcT.dx = dx;
      hcT.tr.scrollLeft = hcT.sl - dx;
    }
    e.stopPropagation();
  }
  function hcTouchEnd() {
    if (!hcT) return;
    var t0 = hcT;
    hcT = null;
    if (t0.dir === 'x') {
      var w = Math.max(t0.tr.clientWidth, 1);
      var n = t0.tr.children.length;
      var i = Math.round(t0.sl / w);
      if (t0.dx < -40) i++;
      else if (t0.dx > 40) i--;
      i = Math.max(0, Math.min(n - 1, i));
      t0.tr.scrollTo({ left: i * w, behavior: 'smooth' });
      setTimeout(function () { t0.tr.style.scrollSnapType = ''; }, 450);
      t0.tr.hcNoClick = Date.now();
    }
    if (t0.fl) setTimeout(function () { t0.fl.isDraggable = true; }, 0);
  }
  window.addEventListener('touchstart', hcTouchStart, { capture: true, passive: true });
  window.addEventListener('touchmove', hcTouchMove, { capture: true, passive: false });
  window.addEventListener('touchend', hcTouchEnd, { capture: true, passive: true });
  window.addEventListener('touchcancel', hcTouchEnd, { capture: true, passive: true });
  /* pointer-events (iOS/Android sturen die ook): niet doorgeven aan Flickity */
  window.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse') return;
    var tr = e.target && e.target.closest && e.target.closest('.hc-cs-track');
    if (tr && hcSlider(tr)) e.stopPropagation();
  }, { capture: true, passive: true });
  /* na een swipe geen klik naar de productpagina */
  window.addEventListener('click', function (e) {
    var tr = e.target && e.target.closest && e.target.closest('.hc-cs-track');
    if (tr && tr.hcNoClick && Date.now() - tr.hcNoClick < 500) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  function scan(root) {
    [].forEach.call((root || document).querySelectorAll('product-card .product-card--featured-image'), init);
  }

  scan();
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      [].forEach.call(m.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('product-card .product-card--featured-image')) init(n);
        else if (n.querySelectorAll) scan(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
